var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "search-item clearfix",
      attrs: { "data-item-id": _vm.item.id },
    },
    [
      _c("div", { staticClass: "item-content" }, [
        _c("div", { staticClass: "list-item-norm-date" }, [
          _vm._v(_vm._s(_vm.item.created)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list-item-norm-title" }, [
          _c("span", {
            staticClass: "list-item-norm-doc-type",
            domProps: { innerHTML: _vm._s(_vm.doc_type) },
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "list-item-norm-doc-number",
            domProps: { innerHTML: _vm._s(_vm.doc_number) },
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "list-item-norm-doc-date-valid",
            domProps: { innerHTML: _vm._s(_vm.doc_date) },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list-item-norm-link" }, [
          _c("a", {
            staticClass: "search-item-link",
            attrs: { href: _vm.item_href },
            domProps: { innerHTML: _vm._s(_vm.item_title) },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list-item-producer" }, [
          _vm._v("\n      " + _vm._s(_vm.item.doc_producer) + "\n      "),
          _vm.item.doc_producer &&
          _vm.item.doc_producer_full &&
          _vm.item.doc_producer != _vm.item.doc_producer_full &&
          _vm.item.doc_producer_full.length
            ? _c("div", { staticClass: "producer-tip" }, [
                _vm._v(_vm._s(_vm.item.doc_producer_full)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "norm-status", class: _vm.status_class }, [
          _vm._v(
            _vm._s(_vm.item.document_status_label) +
              "\n      " +
              _vm._s(
                _vm.item.date_invalid &&
                  _vm.item.date_invalid.length &&
                  _vm.item.document_status == "invalid"
                  ? "(" + _vm.item.date_invalid + ")"
                  : ""
              ) +
              "\n      " +
              _vm._s(
                _vm.item.date_partially_invalid &&
                  _vm.item.date_partially_invalid.length &&
                  _vm.item.document_status == "partially_invalid"
                  ? "(" + _vm.item.date_partially_invalid + ")"
                  : ""
              ) +
              "\n    "
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }